<template>
  <div v-if="data && data.foreignOrganization" class="row-box">
    <!-- основная информация: start -->
    <WrapperField
      v-for="(value, index) in model"
      :key="value + index"
      :data="
        createDataField({
          fieldName: index,
          fieldValue: value,
          fieldGroup: FieldGroup.FOREIGN_ORGANIZATION,
        })
      "
    ></WrapperField>
    <!-- основная информация: end -->

    <!-- ФИО лица, имеющего право без доверенности действовать от имени иностранного юридического лица: start -->
    <TitleField
      v-if="model.isAssignee"
      :fieldName="'isAssignee'"
      :fieldGroup="FieldGroup.FOREIGN_ORGANIZATION"
    />
    <AssigneeSection
      v-if="model.isAssignee"
      :data="model.assignee"
      :documents-hidden="trusteeDocumentsHidden"
    />
    <!-- ФИО лица, имеющего право без доверенности действовать от имени иностранного юридического лица: end -->

    <!-- представитель: start -->
    <template v-if="data.foreignOrganization.isTrustee">
      <TitleField
        fieldName="isTrustee"
        :fieldGroup="FieldGroup.FOREIGN_ORGANIZATION"
      />
      <TrusteeSection
        v-if="data.foreignOrganization.trusteeInfo"
        :data="trusteeInfoData"
        :documents-hidden="
          trusteeDocumentsHidden || trusteeDocumentsHiddenInner
        "
      />
      <TrusteeOrganization
        v-if="data.foreignOrganization.trusteeOrganizationInfo"
        :data="data.foreignOrganization.trusteeOrganizationInfo"
      />
      <TrusteeForeignOrganization
        v-if="data.foreignOrganization.trusteeForeignOrganizationInfo"
        :data="data.foreignOrganization.trusteeForeignOrganizationInfo"
      />
    </template>
    <!-- представитель: end -->
  </div>
</template>

<script>
import { createDataField, FieldGroup } from '@/utils/fullStatementView';
import WrapperField from '@/components/elements/statement/FullStatementView/base/WrapperField';
import TitleField from '@/components/elements/statement/FullStatementView/base/TitleField';
import TrusteeSection from '@/components/elements/statement/FullStatementView/elements/Trustee';
import TrusteeOrganization from '@/components/elements/statement/FullStatementView/elements/TrusteeOrganization';
import TrusteeForeignOrganization from '@/components/elements/statement/FullStatementView/elements/TrusteeForeignOrganization';
import AssigneeSection from '@/components/elements/statement/FullStatementView/elements/Assignee';
import { StatementType } from '@/types/services';
import cloneDeep from 'clone-deep';

export default {
  name: 'ForeignOrganization',
  components: {
    WrapperField,
    TitleField,
    TrusteeSection,
    AssigneeSection,
    TrusteeOrganization,
    TrusteeForeignOrganization,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    statementType: {
      type: String,
    },
    trusteeDocumentsHidden: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    createDataField,
    FieldGroup,
  }),
  computed: {
    trusteeDocumentsHiddenInner() {
      return [StatementType.ROD].includes(this.statementType);
    },
    model() {
      if (!this.data || !this.data.foreignOrganization) return undefined;
      if (
        !this.data.foreignOrganization.isAssignee ||
        this.data.foreignOrganization.assignee
      ) {
        return this.data.foreignOrganization;
      }
      const {
        assigneeLastName,
        assigneeName,
        assigneePatronymic,
        assigneeSnils,
        ...data
      } = this.data.foreignOrganization;

      return {
        ...data,
        assignee: {
          lastName: assigneeLastName,
          name: assigneeName,
          patronymic: assigneePatronymic,
          snils: assigneeSnils,
        },
      };
    },
    trusteeInfoData() {
      if (this.trusteeDocumentsHidden) {
        const res = cloneDeep(this.data.foreignOrganization.trusteeInfo);
        delete res.trusteeStatus;

        return res;
      }

      return this.data.foreignOrganization.trusteeInfo;
    },
  },
};
</script>
